import React, {useEffect, useState} from 'react';

import Base from '@/templates/Base/Base';

import Container from '@Themes/natucare/components/Container/Container';
import Row from '@Themes/natucare/components/Row/Row';
import Column from '@Themes/natucare/components/Column/Column';
import GenericHeading from '@Themes/natucare/modules/GenericHeading/GenericHeading';
import TestimonialTile from '@Themes/natucare/modules/TestimonialTile/TestimonialTile';
import EkomiReviews from '@Themes/natucare/modules/EkomiReviews/EkomiReviews';

import Seo from '@/components/Seo/Seo';

import DATA from '@/data/pl/opinie.data';

import * as styles from './opinie.module.scss';

const timestampToDate = timestamp => {
  const timestampInMilliseconds = timestamp * 1000;

  const date = new Date(timestampInMilliseconds);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

const Testimonial = (props) => {
  const {headerData, footerData, storeSummary} = props.pageContext;
  const [storeSummaryCurrent, setStoreSummaryCurrent] = useState(storeSummary);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('/api/get-ekomi-store-summary');
      const data = await response.json();
      setStoreSummaryCurrent(data);
    };

    fetchData();
  }, []);

  const reviews = storeSummaryCurrent.storeReviewsData.reverse().map(item => ({
    stars: item.rating,
    date: timestampToDate(item.submitted),
    text: item.review
  }));

  return <Base headerData={headerData} footerData={footerData} isKlaviyoPl={true}>
    <Seo {...DATA.seo} structuredData={DATA.schema} hrefLang={DATA.hrefLang} />
    <GenericHeading  {...DATA.genericHeading}/>
    <Container classname={styles.rootContainer}>
      <Row>
        {DATA.columns.map((column, index) => (
          <Column xs={4} sm={index === 1 ? 6 : 5} key={index}>
            {column?.items.map((testimonial, index) => <TestimonialTile {...testimonial} key={index}/>
            )}
          </Column>
        ))}
      </Row>
    </Container>
    <EkomiReviews heading={DATA.reviews.heading} infoText={DATA.reviews.infoText}
                  seal={DATA.seal}
                  rating={{
                    ...DATA.rating,
                    current: storeSummaryCurrent.storeAverageData.rounded_average
                  }}
                  showMoreButtonText={DATA.showMoreButtonText}
                  numberOfRatings={{
                    ...DATA.numberOfRatings,
                    number: storeSummaryCurrent.storeAverageData.number_of_ratings
                  }}
                  reviews={reviews}
    />
  </Base>;
};
export default Testimonial;
